import { useDndContext } from "@dnd-kit/core";
import { EuiIcon } from "@inscopix/ideas-eui";

export interface TableIconProps {
  tableType: "analysis" | "data" | "workflow";
}
export const TableIcon = ({ tableType }: TableIconProps) => {
  const { active } = useDndContext();
  return (
    <EuiIcon
      type={
        tableType === "analysis"
          ? "indexMapping"
          : tableType === "data"
            ? "tableDensityNormal"
            : "layers"
      }
      size="m"
      style={{ verticalAlign: "text-top" }}
      className={`table-icon ${active !== null ? "table-dragging" : ""}`}
    />
  );
};
